import React from 'react'
import getStrings from 'getStrings'
import AppContext from 'core/appContext'


class TeacherSignUpSuccess extends React.Component {
    render() {
        return (
            <div className='form-container form-box'>
                <p>{getStrings().TEACHER_LOUNGE_FORM_SUCCESS}</p>
                <img src={'/images/HappyLlamaMail.png'} alt="Happy Llama" />
            </div>
        )
    }
}

TeacherSignUpSuccess.contextType = AppContext

export default TeacherSignUpSuccess